import { render, staticRenderFns } from "./ParamsSelect.vue?vue&type=template&id=645b9652&"
import script from "./ParamsSelect.vue?vue&type=script&lang=js&"
export * from "./ParamsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports